import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  CardActions,
  Grid,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import Header from "../CompanyHeader";
import { Link } from "react-router-dom";
import { useError } from "../ErrorProvider";
import { withFirebase } from "../Firebase";
import utils from "../utils";

import * as ROUTES from "../../constants/routes";

export const PasswordResetPage = withFirebase(({ firebase }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showError, showSuccess } = useError();

  const sendReset = () => {
    setLoading(true);
    firebase
      .doPasswordReset(email)
      .then(() => {
        showSuccess(
          `An email will be sent to ${email} with password reset instructions.`
        );
      })
      .catch((err) => {
        showError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const isInvalid = email === "" || !utils.validateEmailAddress(email);

  return (
    <Container fixed>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item xs={12} sm={8} md={5}>
          <LoadingOverlay active={loading} spinner>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h4">Forgot Your Password?</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Enter your email address and we'll send you a link to
                      reset your password.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Email"
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(evt) => setEmail(evt.target.value)}
                      onBlur={() =>
                        setEmailError(
                          email !== "" && !utils.validateEmailAddress(email)
                        )
                      }
                      error={emailError}
                      helperText={
                        emailError ? "Enter a valid email address." : ""
                      }
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={isInvalid}
                      onClick={sendReset}
                    >
                      Reset Password
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Link to={ROUTES.SIGNIN}>Back To Sign In</Link>
                  </Grid>
                </Grid>
              </CardActions>
            </Card>
          </LoadingOverlay>
        </Grid>
      </Grid>
    </Container>
  );
});

const PasswordResetLink = () => (
  <Link to={ROUTES.PASSWORDRESET}>Forgot your password?</Link>
);

export default PasswordResetLink;
